export default __webpack_public_path__ + "df61fae9e15986a16fe9593410436e89.png";